// removed by extract-text-webpack-plugin
module.exports = {"map":"Home__map___1C_vh","title":"Home__title___1YbDt","loading":"Home__loading___2Zf9N"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Home.css
// module id = 952
// module chunks = 0